import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      userManagement: {
        ...store.getState().i18n.translations.en.userManagement,
        packageSubManagement: {
          TITLE: 'Package & Subscription Management',
          REQUEST_TYPE: 'Request Type',
          TYPE: 'Type',
          REQUEST_STATUS: 'Request Status',
          PAYMENT_STATUS: 'Payment Status',
          PAYMENT_METHOD: 'Payment Method',
          PURCHASE_DATE: 'Purchase Date',
          REQUEST_TYPES: 'Request Types',
          TYPES: 'Types',
          DATE_REQUESTED: 'Date Requested',
          TOTAL: 'Total',
          TOTAL_VND: 'Total (VND)',
          CONTRACT: 'Contract',
          DETAILS: 'Details',
          DOWNLOAD: 'Download',
          PAY_NOW: 'Pay Now',
          PACKAGE: 'Package',
          SUBSCRIPTION: 'Subscription',
          ALL: 'All',
          DETAIL_REQUEST: 'Detail Request',
          DOWNLOAD_CONFIRMATION: 'Download Confirmation',
          REQUEST_DETAILS_PANEL: 'Request Details',
          VOLUME: 'Volume',
          PRICE: 'Price',
          TRANSACTION_NO: 'Transaction Number',
          REQUEST_NO: 'Request Number',
          TOTAL_PRICE: 'Total Price',
          TRADE_DISCOUNT: 'Trade Discount on Product',
          TRADE_ORDER: 'Trade Discount on',
          REQUEST_INFO: 'Request Information',
          DOWNLOAD_CONTRACT: 'Download Contract',
          CANCEL_REQUEST: 'Cancel Request',
          CANCEL_QUESTION: 'Do you want to cancel this request?',
          CONNECTION_MAP: 'ConnectMap',
          MONTH: '1 Month',
          MONTHS: '%{month} Months',
        },
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      userManagement: {
        ...store.getState().i18n.translations.vi.userManagement,
        packageSubManagement: {
          TITLE: 'Quản Lý Tài Khoản & Gói Dịch Vụ',
          REQUEST_TYPE: 'Loại Yêu Cầu',
          TYPE: 'Loại',
          REQUEST_STATUS: 'Trạng Thái Yêu Cầu',
          PAYMENT_STATUS: 'Trạng Thái Thanh Toán',
          PAYMENT_METHOD: 'Phương Thức Thanh Toán',
          PURCHASE_DATE: 'Ngày Tạo Yêu Cầu',
          REQUEST_TYPES: 'Loại Yêu Cầu',
          TYPES: 'Loại',
          DATE_REQUESTED: 'Ngày Tạo Yêu Cầu',
          TOTAL: 'Tổng Thanh Toán',
          TOTAL_VND: 'Tổng Thanh Toán (VND)',
          CONTRACT: 'Hợp Đồng',
          DETAILS: 'Chi Tiết',
          DOWNLOAD: 'Tải Xuống',
          PAY_NOW: 'Thanh Toán Ngay',
          PACKAGE: 'Gói',
          SUBSCRIPTION: 'Nâng cấp tài khoản',
          ALL: 'Tất cả',
          DETAIL_REQUEST: 'Chi tiết Yêu Cầu',
          DOWNLOAD_CONFIRMATION: 'Tải Xác Nhận',
          REQUEST_DETAILS_PANEL: 'Chi tiết Yêu cầu',
          VOLUME: 'Số Lượng',
          PRICE: 'Giá',
          TRANSACTION_NO: 'Mã Giao Dịch',
          REQUEST_NO: 'Mã Yêu Cầu',
          TOTAL_PRICE: 'Giá',
          TRADE_DISCOUNT: 'CKTM Cho Sản Phẩm',
          TRADE_ORDER: 'CKTM',
          REQUEST_INFO: 'Thông tin Yêu cầu',
          DOWNLOAD_CONTRACT: 'Tải Hợp đồng',
          CANCEL_REQUEST: 'Hủy Yêu Cầu',
          CANCEL_QUESTION: 'Bạn có muốn hủy yêu cầu không?',
          CONNECTION_MAP: 'Bản đồ kết nối',
          MONTH: '1 Tháng',
          MONTHS: '%{month} Tháng',
        },
      },
    },
  }),
)
